// import React from "react";
// import PropTypes from "prop-types";
// import { Button } from "@mui/material";

// function UploadButton({ onFileSelect, fileName ,disabled=false}) {
//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       if (typeof onFileSelect === "function") {
//         onFileSelect(file);
//       } else {
//         console.error("onFileSelect is not a function");
//       }
//     }
//   };

//   return (
//     <div>
//       <input
//         type="file"
//         accept=".pdf,.jpg,.jpeg,.png"
//         style={{ display: "none" }}
//         id={`upload-button-${fileName || "default"}`}
//         onChange={handleFileChange}
//          disabled={disabled} 
//       />
//       <label htmlFor={`upload-button-${fileName || "default"}`}>
//         <Button variant="contained" component="span" disabled={disabled}>
//           Upload
//         </Button>
//       </label>
//       {/* <span style={{ marginLeft: "10px" }}>{fileName}</span> */}
//     </div>
//   );
// }

// UploadButton.propTypes = {
//   onFileSelect: PropTypes.func.isRequired,
//   fileName: PropTypes.string,
//    disabled: PropTypes.string,
// };

// UploadButton.defaultProps = {
//   fileName: "",
// };

// export default UploadButton;

// import React from "react";
// import PropTypes from "prop-types";
// import { Button } from "@mui/material";

// function UploadButton({ onFileSelect, fileName, disabled = false }) {
//   const handleFileChange = (event) => {
//     const file = event.target.files[0];
//     if (file) {
//       if (typeof onFileSelect === "function") {
//         onFileSelect(file);
//       } else {
//         console.error("onFileSelect is not a function");
//       }
//     }
//   };

//   const inputId = `upload-button-${fileName || "default"}`;

//   return (
//     <div>
//       <input
//         type="file"
//         accept=".pdf,.jpg,.jpeg,.png"
//         style={{ display: "none" }}
//         id={inputId}
//         onChange={handleFileChange}
//         disabled={disabled} // ✅ Disables file input
//       />
//       <label htmlFor={inputId}>
//         <Button variant="contained" component="span" disabled={disabled}>
//           Upload
//         </Button>
//       </label>
//       {/* Optionally display file name */}
//       {/* <span style={{ marginLeft: "10px" }}>{fileName}</span> */}
//     </div>
//   );
// }

// UploadButton.propTypes = {
//   onFileSelect: PropTypes.func.isRequired,
//   fileName: PropTypes.string,
//   disabled: PropTypes.bool, // ✅ Correct type
// };

// UploadButton.defaultProps = {
//   fileName: "",
//   disabled: false,
// };

// export default UploadButton;


import React, { useId } from "react";
import PropTypes from "prop-types";
import SoftButton from "components/SoftButton";

function UploadButton({ onFileSelect, disabled = false, accept }) {
  const uniqueId = useId(); // 🔥 unique every time

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file && typeof onFileSelect === "function") {
      onFileSelect(file);
    }
  };

  return (
    <div>
      <input
        type="file"
        accept={accept}
        style={{ display: "none" }}
        id={uniqueId}
        onChange={handleFileChange}
        disabled={disabled}
      />
      <label htmlFor={uniqueId}>
        <SoftButton variant="outlined" component="span" color="info" disabled={disabled}>
          Upload
        </SoftButton>
      </label>
    </div>
  );
}

UploadButton.propTypes = {
  onFileSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  accept: PropTypes.string,
};

UploadButton.defaultProps = {
  disabled: false,
  accept: ".pdf,.jpg,.jpeg,.png",
};

export default UploadButton;
